import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import type RootStackParamList from "../../../navigation/RootStackParamList";
import { auth } from "../../../firebase";
import EtiquetteView from "../ui/EtiquetteView";
import { logViewEtiquette } from "../../../utils/analyticsUtils";

type Props = NativeStackScreenProps<RootStackParamList, "Etiquette">;

export default function EtiquetteScreen({ navigation, route }: Props) {
  const handleContinue = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      // Log etiquette view
      logViewEtiquette();

      // Call the provided callback function
      const { onContinue } = route.params;
      onContinue();
    } catch (error) {
      console.error("Failed to save etiquette agreement:", error);
    }
  };

  return (
    <EtiquetteView
      onContinue={handleContinue}
      onBack={() => navigation.goBack()}
    />
  );
}
